import { render, staticRenderFns } from "./CounterForm.vue?vue&type=template&id=1c407980&scoped=true&"
import script from "./CounterForm.vue?vue&type=script&lang=js&"
export * from "./CounterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c407980",
  null
  
)

component.options.__file = "CounterForm.vue"
export default component.exports